module.exports = __webpack_public_path__ + "img/photo-7-2.e8a27a67.webp";